import React, { useMemo } from 'react'
import { StyleSheet } from 'react-native'
import { v4 as uuidv4 } from 'uuid'

import { Image } from 'widgets/Image'

import { Media } from 'types/media'

import { defaultAvatarImage } from './defaultAvatarImage'

type AvatarProps = {
  width?: number
  height?: number
  image?: Media
  isSquare?: boolean
}

export const Avatar = ({
  width = 24,
  height = 24,
  image = defaultAvatarImage,
  isSquare = false,
}: AvatarProps) => {
  const url = useMemo(
    () => (!image?.url || image.url.length < 1 ? defaultAvatarImage.url : image.url),
    [image.url],
  )
  const imageFileName = useMemo(() => {
    const imageUrlParts = image?.url?.split('/') ?? []
    return imageUrlParts.length > 0
      ? imageUrlParts[imageUrlParts.length - 1]
      : defaultAvatarImage.url
  }, [image?.url])

  const cacheKey = useMemo(() => {
    // eslint-disable-next-line no-underscore-dangle
    if (image?._original?.etag) {
      // eslint-disable-next-line no-underscore-dangle
      return `${imageFileName.split('.')[0]}-${image._original.etag}-avatar`
    }

    return `${imageFileName.split('.')[0]}-avatar`
    // eslint-disable-next-line no-underscore-dangle
  }, [image?._original?.etag, imageFileName])

  const computedStyles = useMemo(
    () =>
      StyleSheet.create({
        image: {
          width,
          height,
          borderRadius: isSquare ? 5 : width * 2,
          backgroundColor: 'white',
        },
      }),
    [width, height, isSquare],
  )

  return (
    <Image
      cacheKey={cacheKey}
      imageWidth={104}
      style={computedStyles.image}
      width={width}
      height={height}
      source={{
        uri: url,
      }}
    />
  )
}
